import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { motion } from 'framer-motion';
import { Trophy, Zap, Users, Target, Award, TrendingUp, Clock, MapPin, GraduationCap, Dumbbell } from 'lucide-react';
import { Button } from '../components/ui/Button';
const trainingPrograms = [{
  icon: GraduationCap,
  title: 'הדרכה אישית',
  description: 'ליווי אישי צמוד למי שרוצה להשתפר בחתירה ספורטיבית',
  features: ['תוכנית אימונים אישית מותאמת', 'שיפור טכניקה ומהירות', 'תזונה וכושר כללי']
}, {
  icon: Dumbbell,
  title: 'אימוני כוח וסבולת',
  description: 'תוכנית אימונים משלימה לשיפור ביצועים',
  features: ['אימוני אינטרוולים במים', 'תרגילי כוח ליבה ויציבות', 'אימוני סבולת למרחקים ארוכים', 'שיפור מהירות ספרינט']
}];
const benefits = [{
  icon: Zap,
  title: 'שיפור ביצועים',
  description: 'אימוני מהירות וסבולת ממוקדים לשיפור כושר וטכניקה'
}, {
  icon: Users,
  title: 'קהילת חותרים ספורטיבית',
  description: 'הצטרפו לקהילת חותרים המחויבים להשתפר'
}, {
  icon: Award,
  title: 'חתירה ברמה גבוהה',
  description: 'ליווי מקצועי לחתירה ספורטיבית ואיכותית'
}, {
  icon: Target,
  title: 'מעקב אישי',
  description: 'תוכנית אימונים אישית ומעקב אחר התקדמות'
}];
export function SUPRacePage() {
  useEffect(() => {
    // Set meta tags for SUP Race page
    document.title = "SUP Race - חתירה ספורטיבית | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'המועדון היחידי בישראל עם קבוצת חתירה ספורטיבית ייעודית - SUP Race בכנרת. אימונים, הדרכות וציוד מקצועי');
    // Open Graph tags with image
    const ogTags = [{
      property: 'og:title',
      content: "SUP Race - חתירה ספורטיבית | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'המועדון היחידי בישראל עם קבוצת חתירה ספורטיבית ייעודית - אימונים והדרכות SUP Race'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7FYEnEHxXy4Ajs6r7s98nx/939A4238.jpg'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:url',
      content: window.location.href
    },
    // Twitter Card tags
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    }, {
      property: 'twitter:title',
      content: "SUP Race - חתירה ספורטיבית | ביץ' קלאב מעגן"
    }, {
      property: 'twitter:description',
      content: 'המועדון היחידי בישראל עם קבוצת חתירה ספורטיבית ייעודית'
    }, {
      property: 'twitter:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7FYEnEHxXy4Ajs6r7s98nx/939A4238.jpg'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-1549">
      <Navigation data-id="element-1550" />

      {/* Hero Section */}
      <div className="relative h-[70vh] overflow-hidden" data-id="element-1551">
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-[#0A5F8F]/90 z-10" data-id="element-1552" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7FYEnEHxXy4Ajs6r7s98nx/939A4238.jpg" alt="SUP Race" className="w-full h-full object-cover" data-id="element-1553" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-1554">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-1555">
            <Trophy className="w-20 h-20 mx-auto mb-6 text-yellow-400" data-id="element-1556" />
            <h1 className="text-5xl md:text-7xl font-bold mb-4" data-id="element-1557">SUP Race</h1>
            <p className="text-xl md:text-2xl max-w-3xl font-light mb-6" data-id="element-1558">
              המועדון היחידי בישראל עם קבוצה ייעודית לחתירה ספורטיבית
            </p>
            <div className="flex items-center justify-center gap-2 text-yellow-400 font-bold text-lg" data-id="element-1559">
              <Award className="w-6 h-6" data-id="element-1560" />
              <span data-id="element-1561">אימונים והדרכות לכל מי שרוצה להשתפר</span>
            </div>
          </motion.div>
        </div>
      </div>

      {/* What is SUP Race Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-1562">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto text-center mb-20" data-id="element-1563">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-6" data-id="element-1564">
            מה זה SUP Race?
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-1565">
            SUP Race הוא חתירה ספורטיבית בעמידה על גלשן צר, ארוך ומהיר. הגלשנים
            מיועדים למהירות מקסימלית - ברוחב של 20-28 אינץ' ובאורך אחיד של 14
            פיט. זהו ספורט המדגיש כוח, סבולת, טכניקה ואסטרטגיה.
          </p>
        </motion.div>

        {/* Unique Advantage */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-3xl p-12 mb-20 border-2 border-yellow-200" data-id="element-1566">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-1567">
            <div className="bg-white p-6 rounded-2xl shadow-lg" data-id="element-1568">
              <Award className="w-16 h-16 text-yellow-500" data-id="element-1569" />
            </div>
            <div className="flex-1 text-center md:text-right" data-id="element-1570">
              <h3 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1571">
                המועדון היחידי בישראל עם קבוצת חתירה ספורטיבית ייעודית
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-1572">
                אנחנו גאים להיות המועדון הראשון והיחיד בישראל שמציע קבוצת אימון
                ייעודית לחתירה ספורטיבית. עם מאמנים מוסמכים, ציוד מקצועי,
                ותוכנית אימונים מובנית - מתאים לכל מי שרוצה להשתפר ולחתור ברמה
                גבוהה יותר, ולמי שמעוניין גם להתחרות.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Training Programs Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-1573">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4 text-center" data-id="element-1574">
            אימונים והדרכות
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-1575">
            תוכניות אימון מקצועיות והדרכה אישית לכל מי שרוצה להשתפר
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 max-w-4xl mx-auto" data-id="element-1576">
            {trainingPrograms.map((program, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-2xl border border-blue-100" data-id="element-1577">
                <div className="bg-white w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-md" data-id="element-1578">
                  <program.icon className="w-8 h-8 text-[#0A5F8F]" data-id="element-1579" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1580">
                  {program.title}
                </h3>

                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-1581">
                  {program.description}
                </p>

                <ul className="space-y-2" data-id="element-1582">
                  {program.features.map((feature, i) => <li key={i} className="flex items-start gap-2 text-gray-700" data-id="element-1583">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1584" />
                      <span className="text-sm" data-id="element-1585">{feature}</span>
                    </li>)}
                </ul>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Race Group - Single Group */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-1586">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4 text-center" data-id="element-1587">
            הקבוצה שלנו
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-1588">
            קבוצת אימון אחת לכל הרמות, עם אימונים מותאמים אישית
          </p>

          <div className="max-w-2xl mx-auto" data-id="element-1589">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300" data-id="element-1590">
              <div className="h-2 bg-gradient-to-r from-blue-500 to-cyan-400" data-id="element-1591" />

              <div className="p-8" data-id="element-1592">
                <div className="bg-gradient-to-br from-gray-50 to-gray-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 mx-auto" data-id="element-1593">
                  <Trophy className="w-8 h-8 text-[#0A5F8F]" data-id="element-1594" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-1595">
                  קבוצת חתירה ספורטיבית
                </h3>
                <div className="inline-block px-3 py-1 rounded-full text-sm font-bold mb-4 bg-gradient-to-r from-blue-500 to-cyan-400 text-white mx-auto block w-fit" data-id="element-1596">
                  All Levels
                </div>

                <p className="text-gray-600 mb-6 leading-relaxed text-center" data-id="element-1597">
                  קבוצה אחת המאחדת חותרים בכל הרמות - ממתחילים ועד מתקדמים. כל
                  חותר מקבל תוכנית אימונים אישית המותאמת לרמתו ויעדיו האישיים.
                  הדגש הוא על שיפור מתמיד וחתירה ספורטיבית ברמה גבוהה.
                </p>

                <div className="flex items-center justify-center gap-2 text-gray-700" data-id="element-1598">
                  <Clock className="w-5 h-5 text-[#0A5F8F]" data-id="element-1599" />
                  <span className="font-semibold text-lg" data-id="element-1600">
                    3-4 אימונים בשבוע
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* Benefits Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-1601">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-12 text-center" data-id="element-1602">
            למה להצטרף לקבוצה שלנו?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1603">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: index % 2 === 0 ? -30 : 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex gap-6 p-6 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl border border-blue-100" data-id="element-1604">
                <div className="bg-white p-4 rounded-xl shadow-sm h-fit" data-id="element-1605">
                  <benefit.icon className="w-8 h-8 text-[#0A5F8F]" data-id="element-1606" />
                </div>
                <div data-id="element-1607">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1608">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1609">
                    {benefit.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Equipment Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gray-50 rounded-3xl p-12 mb-20" data-id="element-1610">
          <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6 text-center" data-id="element-1611">
            הציוד שלנו
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1612">
            <div data-id="element-1613">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1614">
                גלשני RACE מקצועיים
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-1615">
                <li className="flex items-start gap-2" data-id="element-1616">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1617" />
                  <span data-id="element-1618">גלשנים צרים ומהירים ברוחב 20-28 אינץ'</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1619">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1620" />
                  <span data-id="element-1621">אורך אחיד של 14 פיט לכל הגלשנים</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1622">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1623" />
                  <span data-id="element-1624">ציוד מקצועי לחתירה ספורטיבית</span>
                </li>
              </ul>
            </div>
            <div data-id="element-1625">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1626">
                משוטים מקצועיים
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-1627">
                <li className="flex items-start gap-2" data-id="element-1628">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1629" />
                  <span data-id="element-1630">משוטי קרבון קלים ויעילים</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-1631">
                  <div className="w-2 h-2 rounded-full bg-[#0A5F8F] mt-2" data-id="element-1632" />
                  <span data-id="element-1633">ציוד איכותי לחתירה מקצועית</span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>

        {/* CTA Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-[#0A5F8F] to-[#0D7AB8] rounded-3xl p-12 text-center text-white relative overflow-hidden" data-id="element-1634">
          <div className="absolute inset-0 opacity-10" data-id="element-1635">
            <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }} data-id="element-1636" />
          </div>

          <div className="relative z-10" data-id="element-1637">
            <Trophy className="w-16 h-16 mx-auto mb-6 text-yellow-400" data-id="element-1638" />
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1639">
              מוכנים להצטרף לקבוצה?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-1640">
              בואו לאימון ניסיון חינם ותגלו את החתירה הספורטיבית
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1641">
              <Button size="lg" className="bg-white text-[#0A5F8F] hover:bg-blue-50 font-bold" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-1642">
                <span className="text-[#0A5F8F]" data-id="element-1643">הצטרפו אלינו עכשיו</span>
              </Button>
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10" data-id="element-1644">
                <a href="tel:0522632784" className="flex items-center gap-2" data-id="element-1645">
                  התקשרו: 052-2632784
                </a>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>

      <ContactSection data-id="element-1646" />
      <Footer data-id="element-1647" />
    </div>;
}